<template>
    <div>
 
            <!-- blog-details-area -->
            <section class="blog__details-area">
                <div class="container">
                    <div class="blog__inner-wrap">
                        <div class="row">
                            <div class="col-70">
                                <div class="blog__details-wrap">
                                    <!-- <div class="blog__details-thumb">
                                        <img src="assets/img/blog/blog_details01.jpg" alt="Apexa" />
                                    </div> -->

                                    <!-- <pre>{{ list_data }}</pre> -->
                                    
                                    <div class="blog__details-content">
                                        <h2 class="title">{{ $route.name }}</h2>    
                                       
                                        <div class="row gutter-24">
                                            <div class="col-lg-4 col-md-6" v-for="(item, index) in list_data" :key="index">
                                                <div class="project__item-two">
                                                    <div class="project__thumb-two">
                                                        <!-- <img :src="$store.state.UPLOADS+item.file" alt="Apexa" /> -->
                                                        <div class="video-container">
                                                            <iframe 
                                                                    :src="$store.state.UPLOADS+item.file" 
                                                                    frameborder="0" 
                                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                                                    allowfullscreen
                                                                    >
                                                            </iframe>
                                                        </div>
                                                    </div>
                                                    <div class="project__content-two">
                                                        <h2 class="title" style="font-size: 12pt !important;"><a href="javascript:void(0)"  @click="showModal(item)">{{item.judul}}</a></h2>
                                                    </div>
                                                </div>
                                            </div>
 
                                        </div>
                                        <div class="pagination-wrap mt-40 mb-40">
                                            <nav aria-label="Page navigation example">
                                                <ul class="pagination list-wrap">
                                                    <li class="page-item">
                                                        <a class="page-link paginasia" @click="prevPage"  :disabled="currentPage === 1"><i class="fas fa-angle-double-left"></i></a>
                                                    </li>
                                                    <li class="page-item active"><a class="page-link paginasia"  >{{data_ke}}</a></li> 
                                                    <li class="page-item"><a class="page-link paginasia"  >-</a></li>  
                                                    <li class="page-item active"><a class="page-link paginasia"  >{{jml_data}}</a></li> 
                                                    <li class="page-item next-page">
                                                        <a class="page-link paginasia" @click="nextPage" :disabled="currentPage === totalPages"><i class="fas fa-angle-double-right"></i></a>
                                                    </li>
                                                </ul>
                                            </nav>
                                        </div>                                        

                                        

                                    </div>
                                    
 
                                </div>
                            </div>

                            <sidecontentnews></sidecontentnews>

                            
                        </div>
                    </div>
                </div>
            </section>

            <div class="modal fade" id="fotoModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-10" id="exampleModalLabel"> </h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <h1 class="modal-title fs-2 text-center" style="font-size: 10pt !important;">{{form.judul}}</h1> 
                        <video 
                            :src="file_path + form.file" 
                            controls 
                            autoplay 
                            style="width:100%; height:auto;"
                        ></video>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="">Close</button> 
                    </div>
                    </div>
                </div>
            </div>            
    </div>
</template>

 
<script>
export default {
    data() {
        return {
            list_data  : [],
            jml_data   : 0,
            file_path  : this.$store.state.UPLOADS,
            cari       : '',
            data_ke    : 1, 
            mdl_lihat  : false,
            form       : {}
        }
    },
    methods: {

    showModal(data) {
        this.form = data; 
        const modal = new bootstrap.Modal(document.getElementById('fotoModal'));
        modal.show();
    },

 
    getView() { 
        fetch(this.$store.state.URL.video + 'view', {
            method: "POST",
            headers: {
            "content-type": "application/json", 
            }, 
            body:JSON.stringify(
                {
                    data_ke     : this.data_ke, 
                    cari_value  : this.cari
                }
            )
        })
        .then(res => res.json())
        .then(res_data => { 
            this.list_data = res_data.data
            this.jml_data = res_data.jml_data
            console.log(res_data); 
        });     
    },        


    // PAGINASI
    nextPage() {
        if (this.data_ke < this.jml_data) {
            this.data_ke++;
        }
    },
    
    prevPage() {
        if (this.data_ke > 1) {
            this.data_ke--;
        }
    },    
    },
    mounted() {
        this.getView()
        
    },
}
</script>

<style scoped>
    .paginasia{
        font-size: 8pt !important;
        height  : 35px !important;
        width   : 35px !important;
    }

    .video-container {
        position: relative;
        width: 100%;
        padding-bottom: 56.25%; /* 16:9 aspect ratio */
        height: 0;
        overflow: hidden;
        background-color: #000;
        border-radius: 8px;
    }

    .video-container iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: none;
    }
</style>